// extracted by mini-css-extract-plugin
export default {"container":"style_container__El4Cg","year":"style_year__hRU8l","image":"style_image__P0wmP"};